import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { ellipsis } from '@/presentation/utils/text';

const ClaimRewardsLoading = () => {
  return (
    <div className="space-y-4">
      <h1 className="font-medium text-lg">Claim rewards</h1>
      <div className="p-6 h-28 flex justify-center items-center">
        <Icon name={Icons.SPINNER_GAP} className="animate-spin" size={24} />
      </div>
      <p className="text-center text-sm text-gray-500">{`Fetching your claimable balances${ellipsis}`}</p>
    </div>
  );
};

export default ClaimRewardsLoading;
